import Vue from 'vue';
import PortalVue from 'portal-vue'
import Slick from 'vue-slick-carousel-rtl';

export default () => {
    Vue.use(PortalVue)
    Vue.component('Slick', Slick);
};
